import { render } from "./RdvView.vue?vue&type=template&id=1487bbba&scoped=true"
import script from "./RdvView.vue?vue&type=script&lang=js"
export * from "./RdvView.vue?vue&type=script&lang=js"

import "./RdvView.vue?vue&type=style&index=0&id=1487bbba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1487bbba"]])

export default __exports__